<template>
  <div style="min-width: 1200px; min-height: 95vh">
    <q-card style="min-height: 95vh">
      <div class="row q-pa-md">
        <div class="col-12">
          <div class="d-flex justify-content-between">
            <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300">
              Product Detail
            </h4>
            <span class="d-block">
              <q-btn
                @click="closeProductBatches"
                class="q-ml-auto"
                flat
                icon="close"
                round
                size="small"
              ></q-btn>
            </span>
          </div>
        </div>

        <div
          class="col-12"
          style="text-align: center; height: 300px; line-height: 150px"
          v-if="loader && !OnlineProducts"
        >
          <q-spinner-dots color="primary" size="40px" />
        </div>

        <div class="col-12" v-else>
          <div class="col-12 text-primary">
            <div class="text-left q-pa-xs">
              <div>
                <div>
                  <h6 class="q-pt-md pd-heading" style="text-align: left">
                    {{ OnlineProducts[0].name ? OnlineProducts[0].name : "-" }}
                  </h6>
                  <p style="text-align: left">
                    {{
                      OnlineProducts[0].description
                        ? OnlineProducts[0].description
                        : "-"
                    }}
                  </p>
                </div>

                <div class="mt-4">
                  <div class="d-flex justify-content-between">
                    <div class="pd-content">
                      <label>Unit</label>
                      <span>{{
                        OnlineProducts[0].unit ? OnlineProducts[0].unit : "-"
                      }}</span>
                    </div>
                    <div class="pd-content">
                      <label>SKU</label>
                      <span>{{
                        OnlineProducts[0].sku ? OnlineProducts[0].sku : "-"
                      }}</span>
                    </div>
                    <div class="pd-content">
                      <label>OEM CODE</label>
                      <span>{{
                        OnlineProducts[0].oemCode
                          ? OnlineProducts[0].oemCode
                          : "-"
                      }}</span>
                    </div>
                  </div>

                  <div class="d-flex mt-4 justify-content-between">
                    <div class="pd-content">
                      <label>Product Line Code</label>
                      <span>{{
                        OnlineProducts[0].productLineCode
                          ? OnlineProducts[0].productLineCode
                          : "-"
                      }}</span>
                    </div>
                    <div class="pd-content">
                      <label>Stock</label>
                      <span>{{ totalBatchcount }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr
                style="margin-top: 40px; border: 0.5px solid rgb(227, 227, 227)"
              />
            </div>
          </div>
        </div>
        <div
          class="col-12"
          style="text-align: center; height: 200px; line-height: 100px"
          v-if="loader && !batchArr.length"
        >
          <q-spinner-dots color="primary" size="40px" />
        </div>
        <div class="col-12 q-pa-md" v-else>
          <q-table
            :columns="columns"
            :data="batchArr"
            :loading="loader"
            class="table-header"
            flat
            row-key="batch"
            table-class="table-class"
            bordered
            :pagination.sync="pagination"
            :rows-per-page-options="[50, 100, 150, 200, 0]"
          >
            <template v-slot:body="props">
              <q-tr style="height: 5px"> </q-tr>
              <q-tr
                :props="props"
                class="tableItems"
                @mouseover="props.row.isHovered = true"
                @mouseleave="props.row.isHovered = false"
              >
                <q-td :props="props" class="tItem" key="batch">
                  {{ props.row.batch ? props.row.batch : "-" }}
                </q-td>
                <q-td :props="props" class="tItem" key="expiryDate">
                  <template v-if="props.row.expiryDate">
                    {{ props.row.expiryDate | dateFilter }}</template
                  >
                  <template v-else>-</template>
                </q-td>
                <q-td
                  :props="props"
                  class="tItem"
                  key="batchKey"
                  style="width: 200px"
                >
                  <template>
                    <q-btn
                      v-if="props.row.isHovered"
                      @click="sendKey(props.row.id)"
                      color="green"
                      outline
                      >Send Key On Mail</q-btn
                    >
                  </template>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
        <!--</div>-->
      </div>
    </q-card>
  </div>
</template>

<script>
import {
  GET_PRODUCT_BATCHES_ONLINE,
  GET_PRODUCT_DETAIL_BY_ID_ONLINE,
} from "../../graphql/queries/batch";
import moment from "moment";
import axios from "axios";
import Constants from "../../Constants/Constant";

export default {
  name: "ProductBatchesDrawerOnline",
  props: ["productId", "totalBatchcount", "filter"],
  apollo: {
    OnlineProducts: {
      query: GET_PRODUCT_DETAIL_BY_ID_ONLINE,
      fetchPolicy: "network-only",
      skip: true,
      variables() {
        return { productId: this.productId };
      },
    },
  },
  data: function () {
    return {
      Constants: Constants,
      userObj: JSON.parse(localStorage.getItem("user")),
      batchArr: [],
      tempArr: [],
      loader: true,
      // offset: 0,
      // limit: 50,
      pagination: {
        rowsPerPage: 50,
      },
      columns: [
        {
          name: "batch",
          label: "Batch ID",
          field: "batch",
          align: "left",
          sortable: true,
        },
        {
          name: "expiryDate",
          label: "Expiry Date",
          field: "expiryDate",
          align: "left",
          sortable: true,
        },
        {
          name: "batchKey",
          label: "",
          field: "batchKey",
          align: "left",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    combineFilter() {
      return "%" + this.filter + "%";
    },
  },
  methods: {
    closeProductBatches() {
      this.$emit("closeProductBatchesDialog", false);
    },
    // async onLoad(index, done) {
    //   if (this.batchArr.length === this.totalBatchcount || index === 1) {
    //     done();
    //     return;
    //   }
    //   this.offset = this.offset + this.limit;
    //   this.fetchProductBatches(done);
    // },
    sendKey(id) {
      this.$q
        .dialog({
          title: "Send Key on Mail",
          message: "Are you Sure, you want send key on mail?",
          cancel: true,
          persistent: true,
        })
        .onOk(async () => {
          const apiUrl = Constants.api_url + "sendKeyToPartner";
          const orgId = this.userObj?.organization?.id;
          const request = {
            orgId: orgId,
            batchId: id,
          };
          axios.post(apiUrl, request)
            .then((res) => {
              if (res.data.data) {
                this.$q.notify({
                  position: "top-right",
                  message: "Batch key sent successfully.",
                });
              }
            })
            .catch(function (err) {
              console.log("Error while sending batch key.", err);
            })
            .finally(() => {
              console.log("");
            });
        });
    },
    
    async fetchProductBatches(done) {
      let self = this;
      let response = await this.$apollo.query({
        query: GET_PRODUCT_BATCHES_ONLINE,
        variables: {
          orgId: this.userObj.orgId,
          productId: this.productId,
          filter: this.combineFilter,
        },
        fetchPolicy: "network-only",
      });
      if (response.data) {
        response.data.OnlineBatches.forEach(function (curnt) {
          (curnt.isHovered = false), self.batchArr.push(curnt);
        });
        self.tempArr = self.batchArr;
        self.loader = false;
        if (done) done();
      }
    },
    expiryFilter(filterType) {
      return this.tempArr.filter((batch) => {
        if (filterType === "All") {
          return true;
        } else if (filterType === "Expired") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isBefore(
            moment().format("YYYY-MM-DD")
          );
        } else if (filterType === "n7d") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
            moment().format("YYYY-MM-DD"),
            moment().add(7, "days").format("YYYY-MM-DD")
          );
        } else if (filterType === "n30d") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
            moment().format("YYYY-MM-DD"),
            moment().add(30, "days").format("YYYY-MM-DD")
          );
        } else if (filterType === "n3m") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
            moment().format("YYYY-MM-DD"),
            moment().add(3, "months").format("YYYY-MM-DD")
          );
        } else if (filterType === "n6m") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
            moment().format("YYYY-MM-DD"),
            moment().add(6, "months").format("YYYY-MM-DD")
          );
        } else if (filterType === "n1y") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
            moment().format("YYYY-MM-DD"),
            moment().add(12, "months").format("YYYY-MM-DD")
          );
        } else if (filterType === "a1y") {
          return moment(batch.expiryDate, "YYYY-MM-DD").isAfter(
            moment().add(1, "year").format("YYYY-MM-DD")
          );
        }
      });
    },
    showFilteredBatches(filterType) {
      if (filterType === "All") {
        this.batchArr = this.tempArr;
      } else {
        this.batchArr = this.tempArr.filter((batch) => {
          if (filterType === "Expired") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isBefore(
              moment().format("YYYY-MM-DD")
            );
          } else if (filterType === "n7d") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
              moment().format("YYYY-MM-DD"),
              moment().add(7, "days").format("YYYY-MM-DD")
            );
          } else if (filterType === "n30d") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
              moment().format("YYYY-MM-DD"),
              moment().add(30, "days").format("YYYY-MM-DD")
            );
          } else if (filterType === "n3m") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
              moment().format("YYYY-MM-DD"),
              moment().add(3, "months").format("YYYY-MM-DD")
            );
          } else if (filterType === "n6m") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
              moment().format("YYYY-MM-DD"),
              moment().add(6, "months").format("YYYY-MM-DD")
            );
          } else if (filterType === "n1y") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isBetween(
              moment().format("YYYY-MM-DD"),
              moment().add(12, "months").format("YYYY-MM-DD")
            );
          } else if (filterType === "a1y") {
            return moment(batch.expiryDate, "YYYY-MM-DD").isAfter(
              moment().add(1, "year").format("YYYY-MM-DD")
            );
          }
        });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$apollo.queries.OnlineProducts.skip = false;
      this.fetchProductBatches();
    }, 400);
  },
  beforeDestroy() {
    this.$apollo.queries.OnlineProducts.skip = true;
  },
};
</script>

<style lang="stylus">
.table-header {
  /* max height is important */
  .q-table__middle {
    max-height: 600px;
  }

  .q-table__top, .q-table__bottom, thead tr:first-child th { /* bg color is important for th; just specify one */
    background-color: #ffffff;
  }

  thead tr:first-child th {
    position: sticky;
    top: 0;
    opacity: 1;
    z-index: 1;
  }
}
</style>
